export default "__VITE_ASSET__cd30e413__"